import React from 'react';
import ReactDOM from 'react-dom/client';
import './components/trash/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "@propelauth/react";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthProvider authUrl={process.env.REACT_APP_AUTH_URL as string}>
    {/* <React.StrictMode> */}
        <App />
    {/* </React.StrictMode> */}
  </AuthProvider> 
);


// function sendToAnalytics({ id, name, value }) {
//   ga('send', 'event', {
//     eventCategory: 'Web Vitals',
//     eventAction: name,
//     eventValue: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
//     eventLabel: id, // id unique to current page load
//     nonInteraction: true, // avoids affecting bounce rate
//   });
//}


/**
* If you want to start measuring performance in your app, pass a function
* to log results (for example: reportWebVitals(console.log))
* or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
*/
reportWebVitals();

